import {decorate, observable} from 'mobx';
import {BaseModel} from './base';
import {superUser} from './scope';

export const superUserPermission = `exec:${superUser}`;

export class Permission extends BaseModel {
  searchableProperties = ['identifier'];
}

decorate(Permission, {
  id: observable,
  identifier: observable,
  description: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
